<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Urutan Ke-" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Urutan Ke-
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 24"
            hide-details
            type="number"

            v-model="form.template_meta_json_object.urutan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Urutan Ke- {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.urutan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider
          name="Unit" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Unit
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-autocomplete
            filled
            rounded
            dense
            :color="set_color"
            hide-details
            placeholder="Contoh. UMB Boga"

            :loading="process.unit"
            
            :items="units"
            item-value="name"
            item-text="name"
            :item-color="set_color"

            v-model="form.template_meta_json_object.unit"
            :success="form.template_meta_json_object.unit !== '' && valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Unit {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.unit !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </ValidationProvider>
        
        <v-row>
          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Mulai
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_mulai"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_mulai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Mulai" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_mulai"
                      :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Mulai {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  v-model="form.template_meta_json_object.tanggal_mulai"
                  @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Selesai
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_selesai"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_selesai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Selesai" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_selesai"
                      :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Selesai {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  :min="form.template_meta_json_object.tanggal_mulai"
                  v-model="form.template_meta_json_object.tanggal_selesai"
                  @input="picker.tanggal_selesai = false">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="Titip Transfer" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Titip Transfer
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Titip Transfer"
                hide-details
    
                v-model="form.template_meta_json_object.titip"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Titip Transfer {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.titip !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="Pengembalian Kasbon" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Pengembalian Kasbon
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Pengembalian Kasbon"
                hide-details
    
                v-model="form.template_meta_json_object.pengembalian"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Pengembalian Kasbon {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.pengembalian !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="Pendapatan" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Pendapatan
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Pendapatan"
                hide-details
    
                v-model="form.template_meta_json_object.pendapatan"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Pendapatan {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.pendapatan !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="Penyisihan Pajak (11%)" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Penyisihan Pajak (11%)
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Penyisihan Pajak (11%)"
                hide-details
    
                v-model="form.template_meta_json_object.penyisihan"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Penyisihan Pajak (11%) {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.penyisihan !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="PPN (11%)" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                PPN (11%)
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total PPN (11%)"
                hide-details
    
                v-model="form.template_meta_json_object.ppn"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      PPN (11%) {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.ppn !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="PPH 4 (2)" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                PPH 4 (2)
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total PPH 4 (2)"
                hide-details
    
                v-model="form.template_meta_json_object.pph"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      PPH 4 (2) {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.pph !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>  
          <v-col cols="12" md="5">
            <ValidationProvider 
              name="Operasional (5%)" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Operasional (5%)
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Operasional (5%)"
                hide-details
    
                v-model="form.template_meta_json_object.operasional"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Operasional (5%) {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.operasional !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="7">
            <ValidationProvider 
              name="Pengembalian PPH 23 ke Lawan Transaksi" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Pengembalian PPH 23 ke Lawan Transaksi
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Total Pengembalian PPH 23 ke Lawan Transaksi"
                hide-details
    
                v-model="form.template_meta_json_object.lawan"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Pengembalian PPH 23 ke Lawan Transaksi {{ errors[0] }}
                    </v-tooltip>
                  </div>
    
                  <div v-if="form.template_meta_json_object.lawan !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field> 
            </ValidationProvider>
          </v-col>
        </v-row>


        <ValidationProvider 
          name="Nominal Tampungan Pajak" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nominal Tampungan Pajak
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-currency-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Total Nominal Tampungan Pajak"
            hide-details

            v-model="form.template_meta_json_object.nominal_pajak"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nominal Tampungan Pajak {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nominal_pajak !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-currency-field> 
        </ValidationProvider>

        <ValidationProvider 
          name="Nominal Operasional" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nominal Operasional
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-currency-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Total Nominal Operasional"
            hide-details

            v-model="form.template_meta_json_object.nominal_operasional"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nominal Operasional {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nominal_operasional !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-currency-field> 
        </ValidationProvider>

        <ValidationProvider 
          name="Nomor Rekening Unit Bisnis" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nomor Rekening Unit Bisnis
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 24"
            hide-details
            type="number"

            v-model="form.template_meta_json_object.no_rekening"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nomor Rekening Unit Bisnis {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.no_rekening !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="CAD" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            CAD
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-currency-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Total CAD"
            hide-details

            v-model="form.template_meta_json_object.nominal_cad"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  CAD {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nominal_cad !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-currency-field> 
        </ValidationProvider>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal"
                  :success="form.template_meta_json_object.tanggal !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal"
              @input="picker.tanggal = false">
            </v-date-picker>
          </v-menu>
        </div>
  
        <ValidationProvider 
            name="Bendahara Unit Bisnis" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Bendahara Unit Bisnis
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Bendahara Unit Bisnis"
              hide-details
  
              v-model="form.template_meta_json_object.bendahara"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Bendahara Unit Bisnis {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.bendahara !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider> 

        <ValidationProvider 
            name="Manager Unit Bisnis" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Manager Unit Bisnis
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Manager Unit Bisnis"
              hide-details
  
              v-model="form.template_meta_json_object.manager"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Manager Unit Bisnis {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.manager !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Bendahara PT UMB" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Bendahara PT UMB
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Bendahara PT UMB"
              hide-details
  
              v-model="form.template_meta_json_object.bendahara_umb"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Bendahara PT UMB {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.bendahara_umb !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>

  
          <ValidationProvider 
            name="Direktur Utama PT UMB" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Direktur Utama PT UMB
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
              hide-details
  
              v-model="form.template_meta_json_object.direktur_umb"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Direktur Utama PT UMB {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.direktur_umb !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>

      </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-text
              class="black--text py-2" style="font-size: 12px;">
              <div class="text-center body-2 font-weight-bold mb-5">
                <div>
                  PERMOHONAN PENCAIRAN DANA
                </div>
                <div>
                  CASHPOOLING KE-{{ form.template_meta_json_object.urutan === '' ? '____' : form.template_meta_json_object.urutan }}
                </div>
                <div>
                  DARI REKENING UTAMA PT UMB 7447447414
                </div>
              </div>
              
              <div class="mt-4">
                Berikut dana Cashpooling Unit Bisnis {{ form.template_meta_json_object.unit === '' ? '____' : form.template_meta_json_object.unit }} yang telah terverifikasi dari 
                <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                  {{ form.template_meta_json_object.tanggal_mulai | day }}
                </span>

                <span v-else>
                  __________
                </span>

                sampai dengan

                <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                  {{ form.template_meta_json_object.tanggal_selesai | fulldate }}
                </span>

                <span v-else>
                  __________
                </span>
              </div>
              <div
                style="margin-top: 8px !important;">

                <table style="border-collapse: collapse; width: 100%;">
                  <tr>
                    <th colspan="2" style="font-size: 13px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Dana Masuk di Rekening Utama
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 1px; white-space: nowrap;">
                      
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 1px; white-space: nowrap;">
                      
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 1px; white-space: nowrap;">
                      
                    </th>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Titip Transfer
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.titip !== '' && form.template_meta_json_object.titip !== null">
                        Rp. {{ form.template_meta_json_object.titip | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Pengembalian Kasbon
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; min-width: 100px;">
                      <span v-if="form.template_meta_json_object.pengembalian !== '' && form.template_meta_json_object.pengembalian !== null">
                        Rp. {{ form.template_meta_json_object.pengembalian | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; min-width: 100px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; min-width: 100px;">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Pendapatan
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.pendapatan !== '' && form.template_meta_json_object.pendapatan !== null">
                        Rp. {{ form.template_meta_json_object.pendapatan | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <th colspan="2" style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Total Dana Masuk di Rekening Utama
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Rp. {{ (form.template_meta_json_object.pendapatan + form.template_meta_json_object.pengembalian + form.template_meta_json_object.titip) | number}}
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </th>
                  </tr>

                  <tr>
                    <td colspan="2" style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; color: white;">
                      Total Dana Masuk di Rekening Utama
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <th colspan="2" style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Potongan
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </th>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Penyisihan Pajak (11%)
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.penyisihan !== '' && form.template_meta_json_object.penyisihan !== null">
                        Rp. {{ form.template_meta_json_object.penyisihan | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      PPN (11%)
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.ppn !== '' && form.template_meta_json_object.ppn !== null">
                        Rp. {{ form.template_meta_json_object.ppn | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      PPH 4 (2)
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.pph !== '' && form.template_meta_json_object.pph !== null">
                        Rp. {{ form.template_meta_json_object.pph | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Operasional (5%)
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.operasional !== '' && form.template_meta_json_object.operasional !== null">
                        Rp. {{ form.template_meta_json_object.operasional | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: center; width: 50px; max-width: 50px; min-width: 50px;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Pengembalian PPH 23 ke Lawan Transaksi
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      <span v-if="form.template_meta_json_object.lawan !== '' && form.template_meta_json_object.lawan !== null">
                        Rp. {{ form.template_meta_json_object.lawan | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </td>
                  </tr>

                  <tr>
                    <th colspan="2" style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Total Potongan
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                     Rp. {{ (form.template_meta_json_object.penyisihan + form.template_meta_json_object.ppn + form.template_meta_json_object.pph + form.template_meta_json_object.operasional + form.template_meta_json_object.lawan) | number }}
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </th>
                  </tr>

                  <tr>
                    <th colspan="2" style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Total Dana Yang Dicarikan ke VA Rek Unit Bisnis
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left; ">
                    </th>
                    <th style="font-size: 12px; border: 1px solid #ddd; padding: 2px 8px; text-align: left;">
                      Rp. {{ (form.template_meta_json_object.pendapatan + form.template_meta_json_object.pengembalian + form.template_meta_json_object.titip) -(form.template_meta_json_object.penyisihan + form.template_meta_json_object.ppn + form.template_meta_json_object.pph + form.template_meta_json_object.operasional + form.template_meta_json_object.lawan) | number }}
                    </th>
                  </tr>

                </table>

                <div
                  class="mb-0 mt-3"
                  style="margin-bottom: 4px !important;">
                  Dari total dana yang masuk di rekening utama akan didistribusikan ke :
                </div>
                <div>
                  <ol>
                    <li>
                      Rekening VA TAMPUNGAN PAJAK (9738275758100024) sebesar 
                      <span style="font-weight: 500;">
                        Rp. 
                        <span v-if="form.template_meta_json_object.nominal_pajak !== '' && form.template_meta_json_object.nominal_pajak !== null">
                          {{ form.template_meta_json_object.nominal_pajak | number }}
                        </span>
                        <span v-else>
                          _________________
                        </span>
                      </span> 
                    </li>
                    <li>
                      Rekening OPERASIONAL PT UMB (7575811118) sebesar 
                      <span style="font-weight: 500;">
                        Rp. 
                        <span v-if="form.template_meta_json_object.nominal_operasional !== '' && form.template_meta_json_object.nominal_operasional !== null">
                          {{ form.template_meta_json_object.nominal_operasional | number }}
                        </span>
                        <span v-else>
                          _________________
                        </span>
                      </span> 
                    </li>
                    <li>
                      Rekening VA CAD {{ form.template_meta_json_object.unit === '' ? '_____________' : form.template_meta_json_object.unit }} ({{ form.template_meta_json_object.no_rekening === '' ? '_____________' : form.template_meta_json_object.no_rekening }}) sebesar
                      <span style="font-weight: 500;">
                        Rp. 
                        <span v-if="form.template_meta_json_object.nominal_cad !== '' && form.template_meta_json_object.nominal_cad !== null">
                          {{ form.template_meta_json_object.nominal_cad | number }}
                        </span>
                        <span v-else>
                          _________________
                        </span>
                      </span> 
                    </li>
                  </ol> 
                </div>

              </div>

              <v-row
                class="mt-4"
                style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 18px !important;">
                <v-col cols="12">
                  <div class="text-center">
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Bendahara
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.bendahara !== '' ? form.template_meta_json_object.bendahara : '__________' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Manager
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.manager !== '' ? form.template_meta_json_object.manager : '__________' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Bendahara PT UMB
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.bendahara_umb !== '' ? form.template_meta_json_object.bendahara_umb : '__________' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Direktur Utama PT UMB
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.direktur_umb !== '' ? form.template_meta_json_object.direktur_umb : '__________' }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
import { ValidationObserver, ValidationProvider } from "vee-validate";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      formatPrice(value) {
        if (isNaN(value)) return "Not a Number"
        let number = ""
        const reverseNumber = value
          .toString()
          .split("")
          .reverse()
          .join("")
        const arrReverseNumber = [...Array(reverseNumber.length).keys()]
        arrReverseNumber.map(index => {
          if (index % 3 === 0) number += reverseNumber.substr(index, 3) + "."
        })

        return `${
          number.split("", number.length - 1)
          .reverse()
          .join("")
        }`
      },
      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },
      add_desc () {
        this.form.template_meta_json_object.deskripsi.push({
          text: ''
        })
      },
      add_tugas () {
        this.form.template_meta_json_object.tugas.push({
          text: ''
        })
      },
      add_item () {
        this.form.template_meta_json_object.form.template_meta_json_object.push({
          nama: '',
          detail: '',
          qty: '',
          sat: '',
          harga: ''
        })
      },
    }
  }
</script>

<style></style>